(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricControlOwnersListController', Controller);

    Controller.$inject = ['$scope', '$filter', 'topBarService', 'controlOwners', 'aricEnums', 'aricService'];

    function Controller($scope, $filter, topBarService, controlOwners, aricEnums, aricService) {
        topBarService.setTitleAndIcon('ARIC - Control Owners', 'fa fa-eye');

        var pendingInformationOwners      = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.pendingInformation });
        var readyForTestingOwners         = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.readyForTesting });
        var testingInProgressOwners       = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.testingInProgress });
        var testingToReviewOwners         = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.controlTestingToReview});
        var readyForCertificationOwners   = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.readyForCertification });
        var certificationInProgressOwners = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.certificationInProgress});
        var certificationToReviewOwners   = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.certificationToReview });
        var completedOwners               = _.filter(controlOwners, { ControlOwnerStatusValue: aricEnums.controlOwnerStatus.completed });

        $scope.controlOwners = controlOwners;
        $scope.view = {};

        $scope.allStatus = [{
            title: 'Pending Information',
            code: aricEnums.controlOwnerStatus.pendingInformation,
            color: 'label label-gray',
            icon: 'fa fa-flag',
            items: pendingInformationOwners,
            displayedItems: pendingInformationOwners
        }, {
            title: 'Ready For Testing',
            code: aricEnums.controlOwnerStatus.readyForTesting,
            color: 'label label-blue',
            icon: 'fa fa-pencil-square-o',
            items: readyForTestingOwners,
            displayedItems: readyForTestingOwners
        }, {
            title: 'Testing In Progress',
            code: aricEnums.controlOwnerStatus.testingInProgress,
            color: 'label label-cyan',
            icon: 'fa fa-clock-o',
            items: testingInProgressOwners,
            displayedItems: testingInProgressOwners
        }, {
            title: 'Testing To Review',
            code: aricEnums.controlOwnerStatus.controlTestingToReview,
            color: 'label label-warning',
            icon: 'fa fa-clock-o',
            items: testingToReviewOwners,
            displayedItems: testingToReviewOwners
        }, {
            title: 'Ready For Certification',
            code: aricEnums.controlOwnerStatus.readyForCertification,
            color: 'label label-gold',
            icon: 'fa fa-certificate',
            items: readyForCertificationOwners,
            displayedItems: readyForCertificationOwners
        }, {
            title: 'Certification In Progress',
            code: aricEnums.controlOwnerStatus.certificationInProgress,
            color: 'label label-red',
            icon: 'fa fa-clock-o',
            items: certificationInProgressOwners,
            displayedItems: certificationInProgressOwners
        }, {
            title: 'Certification To Review',
            code: aricEnums.controlOwnerStatus.certificationToReview,
            color: 'label label-purple',
            icon: 'fa fa-clock-o',
            items: certificationToReviewOwners,
            displayedItems: certificationToReviewOwners
        }, {
            title: 'Completed',
            code: aricEnums.controlOwnerStatus.completed,
            color: 'label label-green',
            icon: 'fa fa-check-square-o',
            items: completedOwners,
            displayedItems: completedOwners
        }];

        // Toggle filter status selection
        $scope.toggleFilterStatusSelection = function (status) {
            $scope.selectedStatus = $scope.selectedStatus === status ? null : status;
        };

        // Is Status Active?
        $scope.isStatusActive = function (status) {
            return $scope.selectedStatus === status;
        }

        // Get Status Css Classes
        $scope.getStatusCssClasses = function (status) {
            var classes = status.color;

            if ($scope.isStatusActive(status)) {
                classes += ' is-active';
            }

            return classes;
        };

        // Send Reminder
        $scope.sendReminderToOwner = function(controlOwner) {
            if (controlOwner.isSendingInvitation) {
                return;
            }

            controlOwner.isSendingInvitation = true;
            return aricService
                .sendReminderToCertificationOwner(controlOwner)
                .then(function(updatedOwner) {
                    _.assign(controlOwner, updatedOwner);
                })
                .finally(function() {
                    controlOwner.isSendingInvitation = false;
                });
        }

        // Clear Filter
        $scope.clearFilter = function () {
            $scope.selectedStatus = null;
        };

        // Search
        $scope.searchOwners = function (q) {
            var columnsToSearch = ['DisplayName', 'EmployeePositionEN', 'EmployeeDepartmentEN', 'EmployeeEmail'];

            _.forEach($scope.allStatus, function (status) {
                status.displayedItems = $filter('filterBy')(status.items, columnsToSearch, q);
            });
        };
    }
})();